"use client"

import { Text } from "@medusajs/ui"
import { useTranslation } from "react-i18next"

export const FooterCopyright = () => {
  const { t } = useTranslation()

  return (
    <Text className="txt-compact-small">
      {t("footer.copyright", { year: new Date().getFullYear() })}
    </Text>
  )
}

export default FooterCopyright

